<template>
    <div class="CShareWhatsapp">
        <CButton class="w-full" icon="whatsapp" label-class="sm:hidden" variant="whatsapp" @click="whatsappLink">
            WhatsApp
        </CButton>
    </div>
</template>

<script setup lang="ts">
import { useSharing } from '@/composables/sharing/useSharing'

interface Props {
    url: string
    title?: string
}

const props = withDefaults(defineProps<Props>(), {
    title: ''
})

const { objectToGetParams } = useSharing()

const separator = ' '

const whatsappLink = () => {
    window.open(
        'https://api.whatsapp.com/send' +
            objectToGetParams({
                text: props.title ? props.title + separator + props.url : props.url
            }),
        '__blank'
    )
}
</script>
